import { getMediaUrl } from "config/env";
// Prefer image_thumbnail, then image_optimized, then image, followed by icon columns.
export const getLocationImage = (item) => item?.image_thumbnail || item?.image_optimized || item?.image || item?.icon_thumbnail || item?.icon_optimized || item?.icon || "";
export const getLocationImageUrl = (item) => getMediaUrl(getLocationImage(item));
